var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _g, _rect4, _rect5, _rect6, _circle4, _circle5, _circle6, _rect7, _rect8, _rect9, _circle7, _circle8, _circle9, _g2, _g3, _polygon, _ellipse, _polygon2, _path, _path2, _polygon3, _path3, _polygon4, _path4, _path5, _circle10, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 884.54918,
    height: 560,
    viewBox: "0 0 884.54918 560",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "e95f2213-9bcc-4eb0-8355-05af38a3eafb",
    "data-name": "Rectangle 246",
    x: 0.24277,
    y: 0.32251,
    width: 397.42609,
    height: 208.67749,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "b36aff44-79c8-4945-b2be-fafe94103ec8",
    "data-name": "Rectangle 264",
    width: 397.42609,
    height: 24.19149,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "e8d246b5-3278-4a22-b53c-870d78135d7d",
    "data-name": "Rectangle 247",
    x: 9.23028,
    y: 34,
    width: 381,
    height: 164,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "af47f094-7758-4c77-9c4d-96df8007094d",
    "data-name": "Ellipse 194",
    cx: 37.66058,
    cy: 12.03393,
    r: 4.00175,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a9e4940e-a814-4d65-8cf9-dbeaebbe294d",
    "data-name": "Ellipse 195",
    cx: 52.85057,
    cy: 12.03393,
    r: 4.00175,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a19a9b15-8247-4a07-9472-be354b993276",
    "data-name": "Ellipse 246",
    cx: 22.43115,
    cy: 12.03393,
    r: 4.00175,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e40d22fe-578f-4c94-aa61-62d9a8853a42",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fc650e0a-90d3-4f46-9c22-349406f6a431",
    "data-name": "Rectangle 250",
    x: 94.66582,
    y: 82.05956,
    width: 219.08741,
    height: 9.76443,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a9c22b9d-d16d-4876-9a73-2e204591d63b",
    "data-name": "Rectangle 251",
    x: 94.66582,
    y: 106.47031,
    width: 78.11479,
    height: 9.76443,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a9cac377-a398-4b66-a887-af8e1ff2458e",
    "data-name": "Rectangle 252",
    x: 94.66582,
    y: 130.88106,
    width: 155.61961,
    height: 9.76443,
    fill: "#f2f2f2"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "ae236caa-6983-426a-9b06-907acb2b0100",
    "data-name": "Rectangle 246",
    x: 90.22846,
    y: 273.62195,
    width: 374.00182,
    height: 196.37805,
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "a3b9e66a-d826-4708-839f-4ee527686343",
    "data-name": "Rectangle 264",
    x: 90,
    y: 273.31845,
    width: 374.00182,
    height: 22.76564,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "aab7f417-816b-4c9c-990d-381bde365131",
    "data-name": "Rectangle 247",
    x: 98.11455,
    y: 304,
    width: 359.11573,
    height: 156,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "f8f639d0-e29b-4d5a-b588-284205311750",
    "data-name": "Ellipse 194",
    cx: 125.44086,
    cy: 284.6431,
    r: 3.76589,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "b51d82ba-e700-447e-8693-718cbf9a6186",
    "data-name": "Ellipse 195",
    cx: 139.73556,
    cy: 284.6431,
    r: 3.76589,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "adf412b1-46d6-41c6-a8e7-cb0dafcb21cb",
    "data-name": "Ellipse 246",
    cx: 111.10906,
    cy: 284.6431,
    r: 3.76589,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "bb724a05-1311-47ea-a197-dba61202444a",
    "data-name": "Rectangle 246",
    x: 270.271,
    y: 86.06159,
    width: 443.63098,
    height: 232.93841,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "b7251c64-c1f0-4c9d-92b0-874b7a83a8e9",
    "data-name": "Rectangle 264",
    x: 270,
    y: 85.70159,
    width: 443.63098,
    height: 27.004,
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "ab817a57-2f27-4757-8aa6-60cd0ec7b964",
    "data-name": "Rectangle 247",
    x: 280.23028,
    y: 121,
    width: 423,
    height: 185,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "a7798ced-ee1a-4794-8024-1e89386a0136",
    "data-name": "Ellipse 194",
    cx: 312.03901,
    cy: 99.13459,
    r: 4.467,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "a86efddc-376d-49bc-bb2f-084d39c183b3",
    "data-name": "Ellipse 195",
    cx: 328.995,
    cy: 99.13459,
    r: 4.467,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "be9ec433-53e3-4401-a112-00f5748904d3",
    "data-name": "Ellipse 246",
    cx: 295.03901,
    cy: 99.13459,
    r: 4.467,
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e9ebe1f0-a35b-432b-8b90-74480dfb3bf9",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "f96caaa1-6c15-4961-b53f-9d0c3661d201",
    "data-name": "Rectangle 250",
    x: 329.78549,
    y: 168.6355,
    width: 324.33099,
    height: 14.455,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b84ba293-ba99-4f02-8939-e0d4d3784a38",
    "data-name": "Rectangle 251",
    x: 329.78549,
    y: 204.7725,
    width: 115.639,
    height: 14.455,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b3127a43-0306-472e-b694-e809c29e74cb",
    "data-name": "Rectangle 252",
    x: 329.78549,
    y: 240.9095,
    width: 230.375,
    height: 14.455,
    fill: "#e6e6e6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b98a0618-17e9-4407-b210-398d3f3d6a2f",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "f815513a-42d1-48f0-8051-0e3f5098eb8b",
    "data-name": "Rectangle 250",
    x: 163.6717,
    y: 350.30143,
    width: 244.55858,
    height: 10.89965,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "fd32ddd7-816d-43c9-8317-e96306581af5",
    "data-name": "Rectangle 251",
    x: 163.6717,
    y: 377.55017,
    width: 87.19645,
    height: 10.89965,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "eae90b12-7883-428a-9e47-6f1258f1f191",
    "data-name": "Rectangle 252",
    x: 163.6717,
    y: 404.79892,
    width: 173.71199,
    height: 10.89965,
    fill: "#f2f2f2"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "502.342 89.215 481.491 100.766 503.728 92.924 502.342 89.215",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 665.84471,
    cy: 259.43493,
    rx: 5.81718,
    ry: 11.71979,
    transform: "translate(-205.30234 48.38338) rotate(-17.99425)",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "509.46 82.667 523.29 77.675 526.23 85.817 512.845 94.858 509.46 82.667",
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M677.57211,256.66414a13.47016,13.47016,0,0,0,18.88348,8.36887l34.02,33.67523L735.352,274.316l-33.05362-28.239a13.54316,13.54316,0,0,0-24.72631,10.58715Z",
    transform: "translate(-157.72541 -170)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M936.8278,469.12849a13.47014,13.47014,0,0,0-3.16469-20.411l9.9463-46.82367-23.15832,9.08046-5.89475,43.07241a13.54316,13.54316,0,0,0,22.27146,15.08179Z",
    transform: "translate(-157.72541 -170)",
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "667.031 543.156 650.608 543.156 642.795 479.811 667.033 479.812 667.031 543.156",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M828.944,729.07558l-52.95288-.002v-.66977A20.61031,20.61031,0,0,1,796.602,707.79331h.0013l32.34169.00131Z",
    transform: "translate(-157.72541 -170)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "747.403 543.156 730.981 543.156 723.168 479.811 747.406 479.812 747.403 543.156",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M909.31663,729.07558l-52.95288-.002v-.66977a20.61029,20.61029,0,0,1,20.61086-20.61054h.00131l32.34169.00131Z",
    transform: "translate(-157.72541 -170)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M826.467,680.08l-23.24744-.9301a6.04689,6.04689,0,0,1-5.784-6.20716l6.54958-214.83465.42776-.15436c40.74393-14.73891,74.44969-13.62437,103.04582,3.40249l.31984.191,3.92347,209.2397a6.02739,6.02739,0,0,1-6.027,6.14176H886.0721a6.04128,6.04128,0,0,1-5.91512-4.865L853.45309,536.22158a2.009,2.009,0,0,0-3.966.14652L832.69179,674.78331a6.06215,6.06215,0,0,1-5.98675,5.30062C826.62623,680.08393,826.54643,680.08262,826.467,680.08Z",
    transform: "translate(-157.72541 -170)",
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 849.08311,
    cy: 236.804,
    r: 32.90059,
    transform: "translate(-167.25852 266.29448) rotate(-28.66347)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M702.90807,269.53086A6.0355,6.0355,0,0,1,705.351,266.89l9.92209-5.69734a6.04761,6.04761,0,0,1,6.89787.62862l32.96658,27.92846,75.77217,21.24389a19.41873,19.41873,0,1,1-16.51422,35.15149l-48.40177-10.89628a62.11929,62.11929,0,0,1-36.5541-23.9993l-25.957-35.579a6.0346,6.0346,0,0,1-1.02618-4.80669A5.96744,5.96744,0,0,1,702.90807,269.53086Z",
    transform: "translate(-157.72541 -170)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M935.423,438.81388a6.03548,6.03548,0,0,1-3.59411.15526l-11.05723-2.94027a6.04762,6.04762,0,0,1-4.45566-5.30309l-3.7459-43.04373-38.84923-68.43583a19.41873,19.41873,0,1,1,36.4767-13.33406l26.69878,41.81668a62.11941,62.11941,0,0,1,9.05992,42.77951l-6.61835,43.54116a6.03461,6.03461,0,0,1-2.65563,4.13581A5.96772,5.96772,0,0,1,935.423,438.81388Z",
    transform: "translate(-157.72541 -170)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M813.0967,295.23124a56.02309,56.02309,0,0,1,44.92444-18.16365q.82512.051,1.64369.11512h.00066a55.905,55.905,0,0,1,40.40021,22.2987,56.74581,56.74581,0,0,1,10.07994,45.73812,177.30338,177.30338,0,0,0,4.68382,90.92287l8.82608,27.40572a6.026,6.026,0,0,1-5.41442,7.8659l-45.12263,2.426-11.547-19.94543v20.56623l-54.84217,2.94848c-.10923.00654-.21781.00916-.32573.00916a6.028,6.028,0,0,1-6.00637-6.512l6.19866-76.86551-7.775-52.2056A56.38041,56.38041,0,0,1,813.0967,295.23124Z",
    transform: "translate(-157.72541 -170)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M871.94892,268.21228c-3.04612,1.75271-15.08657,2.91479-15.9443-.4933l-.01838-.07488c-.59711-2.49707-.10127-5.10458.0701-7.66632s-.07938-5.37595-1.82412-7.25949c-3.25241-3.51113-9.03865-1.64985-13.74164-2.53763A11.6062,11.6062,0,0,1,831.462,237.786c.067-.53247.172-1.06554.28978-1.59828a8.93862,8.93862,0,0,0-9.27869-10.82526c-4.75284.27178-9.8831,1.7118-13.81548-1.80854-3.04091-2.72226-3.78282-9.80862-2.44673-13.66513,2.24539-6.48113,16.6287-9.87411,22.90869-11.73933a54.41263,54.41263,0,0,1,46.121,7.56782c3.96664,2.79595,7.67106,6.309,9.36172,10.858s.875,10.28809-2.93732,13.291a24.55655,24.55655,0,0,1,5.688,23.85251C885.4699,259.78622,876.48322,265.60329,871.94892,268.21228Z",
    transform: "translate(-157.72541 -170)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.27459,730h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-157.72541 -170)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/Subject.7cfcfe68f3808dfe543c779999a94550.svg";
export { ForwardRef as ReactComponent };